import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {formatCurrency, handleDefaultValues, truncDetail} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {getInventoryEvent, getInventoryMemberships} from "../../common/api/PortalCustomerApi";
import {Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import ViewInventoryModal from "../modal/ViewInventoryModal";
import {CartContext} from "../../../lib/CartProvider";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import {AllInclusive, Circle, People, RefreshOutlined, RemoveCircle} from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MembershipPerks from "../perks/MembershipPerks";
import FileSelector from "./calendarUI/FilterSelector";
import {useSearchParams} from "react-router-dom";
import {CompanyContext} from "../../../lib/CompanyProvider";
import {useDragScroll} from "../../common/ux/useDragScroll";
import LockPersonIcon from '@mui/icons-material/LockPerson';

export default function InventoryMiniPane({handleSave, filters, type}) {
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useState(CartContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const {containerRef, dragHandlers} = useDragScroll();

  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();
  const [memberships, setMemberships] = useState([]);

  const [accountTypes, setAccountTypes] = useState([]);

  const [membershipTypeFilter, setMembershipTypeFilter] = useState([]);
  const [membershipTypes, setMembershipTypes] = useState([]);

  const [pageReady, setPageReady] = useState(false);

  const showItemSibling = (item) => {
    if (!filters || filters.length === 0) {
      return true;
    }

    let showAll = false;
    let showSiblingOptions = false;
    for (let j in filters) {
      if (filters[j] === -1) {
        showAll = true;
      }
      if (filters[j] === 1) {
        showSiblingOptions = true;
      }
    }
    if (showAll) {
      return true;
    }
    if (showSiblingOptions && item.siblingMembership) {
      return true;
    }
    return false;
  }

  const showHeader = (accountType) => {
    let item = {
      accountType: accountType
    }
    return showItem(item);
  }

  const showItem = (_item) => {
    let show = (accountTypeFilter.length === 0 || accountTypeFilter.indexOf(_item.accountType?.id) > -1);
    if (!show) {
      return false;
    }

    return show;
  };

  useEffect(() => {
    getInventoryMembershipsFn()
  }, []);

  const [inventory, setInventory] = useState();
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [savingMembership, setSavingMembership] = useState(false);

  const getInventoryEventFn = async (eventId) => {
    getInventoryEvent(eventId).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEvent(result);
        setEventReady(true);
      }
    });
  }

  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    setShowMembershipModal(false);
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const [accountTypeFilter, setAccountTypeFilter] = useState([]);

  useEffect(() => {
    let _params = searchParams.get('accountType');
    if (_params) {
      let _types = _params.split(',');
      let _list = [];
      for (let j in _types) {
        _list.push(parseInt(_types[j], 10));
      }
      setAccountTypeFilter(_list);
    }
  }, [])

  useEffect(() => {
    if (accountTypeFilter && accountTypeFilter?.length > 0) {
      searchParams.set('accountType', accountTypeFilter.join(','))
    } else {
      searchParams.delete('accountType');
    }
    setSearchParams(searchParams);
  }, [accountTypeFilter])

  const getInventoryMembershipsFn = async () => {
    let result = await getInventoryMemberships();
    if (result) {
      let _types = []
      let _accountTypes = []
      for (let j in result) {
        if (result[j].accountType != null && result[j].accountType?.id > 0) {
          if (_types.indexOf(result[j].accountType?.id) == -1) {
            _types.push(result[j].accountType?.id);
            _accountTypes.push(result[j].accountType);
          }
        }
      }
      setAccountTypes(_accountTypes);
      setMemberships(result);
    }
  }

  const viewInventory = (e) => {
    setInventory(e);
    setShowMembershipModal(true);
  };

  const loadCartFn = () => {

    setCartContext({...cartContext, reloadCart: true, caller: 'inventory mini pane'})

    let _context = {...context};
    _context.toast = {
      message: 'Added to cart!',
      type: 'success'
    }
    setContext({..._context});
  };

  const [inventoryTypeFilter, setInventoryTypeFilter] = useState([]);

  const showInventoryTypeHeader = (type) => {
    if (!inventoryTypeFilter.length) {
      return true;
    }
    for (let f in inventoryTypeFilter) {
      if (inventoryTypeFilter[f] === type.id) {
        return true;
      }
    }
    return false;
  }

  return (
    <>
      <MDBox>
        <MDBox style={{
          width: '100%',
          display: 'block'
        }}>
          {accountTypes?.length > 0 && <><FileSelector
            types={accountTypes}
            typeFilter={accountTypeFilter}
            filterLabel={'Membership Types'}
            setFilter={(filters) => {
              setAccountTypeFilter(filters)
            }}
          /></>
          }
        </MDBox>
        <MDBox style={{
          paddingTop: '16px',
          position: 'sticky',
          top: '-10px',
          zIndex: '999',
          background: '#fff',
        }}>
          {accountTypes?.length > 0 && <>
            <div className="tab-container"
                 ref={containerRef} {...dragHandlers}>
              <ul className={'tab-navigation'}>
                {accountTypes?.sort((a, b) => a.sortOrder - b.sortOrder).map((t, idx) => {
                  return (
                    <li key={idx} className={'tab-item'}>
                      <MDButton
                        disabled={!showHeader(t)}
                        onClick={(e) => {
                          document.getElementById('at-' + t.id)?.scrollIntoView({behavior: 'smooth'});
                        }}
                        style={{
                          border: 'solid 1px #ddd',
                          color: '#666',
                          marginRight: '4px',
                        }} size="small" variant="outlined">{t.name}</MDButton>
                    </li>
                  )
                })
                }
              </ul>
            </div>
          </>}
        </MDBox>
        <Grid container cols={2} spacing={2} direction="row">
          <Grid item sm={12}>
            <Grid container spacing={2}>

              {memberships?.length > 0 && <>
                {accountTypes?.filter((t) => showInventoryTypeHeader(t) && showHeader(t)).sort((a, b) => a.sortOrder - b.sortOrder)?.map((t, idx) => {
                  return (
                    <div className={'d-block my-2 pt-4'} style={{
                      display: 'block',
                      width: '100%',
                      margin: '20px',
                      paddingTop: '10px',
                    }} key={idx}>
                      <div id={'at-' + t.id} style={{
                        position: 'relative',
                        left: '-999em',
                        top: '-40px'
                      }}>x
                      </div>
                      <h5>{t.name}</h5>
                      <Grid container spacing={2} key={idx}>
                        {memberships?.sort((a, b) => a.accountType?.sortOrder - b.accountType?.sortOrder)
                          .sort((a, b) => a.price - b.price)
                          .filter(item => item.accountType.id === t.id && showItem(item))
                          .map((inventory, index) => {
                            return (
                              <Grid item md={6} sm={6} xs={12} key={index}
                                    className={'d-inline-grid'}>
                                <div className={'psb-bordered psb-carded'}>

                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={3}>
                                      <>
                                        {inventory?.imageUrl ? <img
                                          style={{
                                            maxWidth: '95%',
                                            height: 'auto'
                                          }}
                                          alt={inventory.name}
                                          src={inventory?.imageThumbUrl || inventory?.imageUrl}
                                        /> : <>&nbsp;</>
                                        }
                                        {inventory?.accountType?.siblingOptionsEnabled && <>
                                    <span style={{
                                      float: 'right',
                                      border: 'solid 1px #ccc',
                                      borderRadius: '25px',
                                      padding: '4px 8px',
                                      background: '#fff',
                                      position: 'relative',
                                      bottom: '25px',
                                      right: '-15px',
                                      zIndex: '5'
                                    }}>
                                      <GroupAddIcon/>
                                    </span>
                                        </>}
                                      </>

                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <h5 style={{
                                        fontWeight: 'bold'
                                      }}>
                                        {inventory.name}
                                        {inventory?.accountType?.siblingOptionsEnabled && <>
                                          <p><b><small>Discount Sibling Rate</small></b></p>
                                        </>}
                                      </h5>
                                      <p>
                                        <small>{inventory.accountType?.name}</small>
                                      </p>


                                      <MDBox mt={1}>
                                        {inventory?.accountType?.recurring &&
                                          <>
                                            <p><small><RefreshOutlined/> Recurring
                                              {inventory?.accountType?.recurrencePattern === 'TIME_BASED_RECURRING' && ' every ' +
                                                inventory?.accountType.membershipTimeDays + ' Days'}
                                            </small></p>

                                            {(!inventory.minimumCancellationDays && !inventory?.minimumMembership && companyContext?.company?.preferences['hide_cancel_anytime'] !== 'true') && <>
                                              <p><small><RemoveCircle/> Cancel at any time</small></p>
                                            </>}
                                          </>
                                        }
                                        {inventory?.accountType?.unlimitedVisits &&
                                          <>
                                            <p><small><AllInclusive/> Unlimited Visits</small></p>
                                          </>
                                        }
                                        {inventory?.accountType?.timeBased &&
                                          <>
                                            <p><small><AccessTimeIcon/> Expires in
                                              Days {inventory?.accountType?.membershipTimeDays}</small>
                                            </p>
                                          </>
                                        }
                                        {inventory?.siblingMembership && <>
                                          <>
                                            <p><small><People/> Sibling
                                              Rate {formatCurrency(inventory?.siblingMembership?.price)}</small></p>
                                          </>
                                        </>}

                                        {inventory?.minimumCancellationDays &&
                                          <>
                                          <p><small><LockPersonIcon/> Cancellation Notice
                                             &nbsp;{inventory?.minimumCancellationDays} {inventory?.minimumCancellationDays === 1 ? 'Day' : 'Days'}
                                          </small>
                                        </p>
                                          </>}


                                          <MembershipPerks inventory={inventory}/>

                                      </MDBox>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                      <p style={{
                                        textAlign: 'right'
                                      }}>
                                        <b
                                          className={inventory?.accountType?.siblingOptionsEnabled ? 'text-decoration-line-through' : ''}>
                                          {formatCurrency(inventory?.price)}
                                        </b>
                                        {inventory?.accountType?.siblingOptionsEnabled && <b>
                                          <br/>
                                          {formatCurrency(inventory.discountPrice)}
                                        </b>}
                                      </p>
                                    </Grid>
                                  </Grid>
                                  <Grid container>
                                    <Grid item xs={12} alignContent={'flex-end'}>
                                      <MDBox display="flex" className={'mt-2'} justifyContent="flex-end">
                                        <MDButton
                                          size={'small'}
                                          color="secondary"
                                          onClick={(e) => {
                                            viewInventory(inventory);
                                          }}>View Details</MDButton>
                                      </MDBox>
                                    </Grid>
                                  </Grid>
                                </div>
                              </Grid>
                            )
                          })
                        }
                      </Grid>
                    </div>
                  )
                })
                }
              </>
              }


            </Grid>
          </Grid>
        </Grid>
      </MDBox>

      {
        inventory && <ViewInventoryModal
          key={inventory?.guid}
          handleClose={handleClose}
          handleSave={handleSave}
          membershipType={true}
          show={showMembershipModal}
          inventory={inventory}
        />
      }

    </>
  )
}